import { Routes, Route, Navigate } from "react-router-dom";
import AdminLogin            from "./AdminLogin";
import AdminLayout           from "./AdminLayout";
import AdminDashboard        from "./AdminDashboard";
import ManageUsers           from "./ManageUsers";
import ManageProducts        from "./ManageProducts";
import ManageOrders          from "./ManageOrders";
import ManageCategories      from "./ManageCategories";
import ManageReports         from "./ManageReports";
import ManageCustomizations  from "./ManageCustomizations";
import ManageArchives        from "./ManageArchives";
import GeneralSettings       from "./GeneralSettings";

const isAdminLoggedIn = () => !!localStorage.getItem("admin_token");

const Protected = ({ children }) =>
  isAdminLoggedIn() ? children : <Navigate to="/admin/login" replace />;

export default function AdminApp() {
  return (
    <Routes>
      <Route path="login" element={<AdminLogin />} />
      <Route path="/" element={<Protected><AdminLayout /></Protected>}>
        <Route index                   element={<AdminDashboard />} />
        <Route path="users"            element={<ManageUsers />} />
        <Route path="products"         element={<ManageProducts />} />
        <Route path="orders"           element={<ManageOrders />} />
        <Route path="categories"       element={<ManageCategories />} />
        <Route path="reports"          element={<ManageReports />} />
        <Route path="customizations"   element={<ManageCustomizations />} />
        <Route path="archives"          element={<ManageArchives />} />
        <Route path="settings"          element={<GeneralSettings />} />
      </Route>
      <Route path="*" element={<Navigate to="/admin/" replace />} />
    </Routes>
  );
}